// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"e451b823","183":"07ed57c5","351":"c5af6898","357":"5baeebdd","428":"f4e68e0a","685":"8aa003fd","695":"abd8bfa3","851":"f6e0f8da","882":"1de2fd01","929":"1f8d38bc"}[chunkId] + ".chunk.js";
};